import React from "react";
import {useNavigate, useLocation} from "react-router-dom";
import "../../styles/OrderSuccessPage.css";

const OrderSuccessPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { orderId } = location.state || {}

    const handleGoToStores = () => {
        navigate("/"); // Переход на страницу выбора магазина
    };

    return (
        <div className="order-success-page">
            <div>
                <h1>Замовлення №{orderId} сформоване</h1>
                <img src="/images/success.svg" alt="Success"/>
                <h1>Дякуємо, що обрали нас!</h1>
            </div>

            <button
                className="primary_button"
                id="back-to-stores-btn"
                onClick={handleGoToStores}>
                Повернутися до покупок
            </button>
        </div>
    );
};

export default OrderSuccessPage;
